import {createContext} from "react";
import * as React from "react";

export type PopUpContextType = {
	addPopUp: ({title}: { title: string, content: React.ReactElement }) => void,
	clearPopUps: () => void,
	closePopUp: (index?: number) => void,
	addAlert: (props: { content: string, severity?: 'error' | 'success' | 'info' | 'warning', time?: number }) => void
}

export const PopUpContext = createContext<PopUpContextType | null>(null)